import { FC, useEffect } from "react";
import { FallbackProps } from "react-error-boundary";
import { useAppNavigate } from "../../../hooks/router";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../hooks/redux";

interface ErrorComponentProps extends FallbackProps {
  connectionStatus?: boolean;
}

export const ErrorComponent: FC<ErrorComponentProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const navigate = useAppNavigate();
  const location = useLocation();

  const fieldTeamMember = useAppSelector(
    (state) => state.auth.fieldTeamMember
  );
  /** Field Setup store has no network slice; treat as online for error-boundary UX. */
  const connectionStatus = true;

  const logErrorBoundary = (error: Error) => {
    const errorArr = error.stack?.split("\n");

    if (import.meta.env.DEV) {
      console.warn("error-boundry-exception", {
        email: fieldTeamMember?.email,
        cUserId: fieldTeamMember?.id,
        location: location,
        error: {
          name: error.name,
          stack: errorArr,
          cause: error.cause,
          message: error.message,
        },
      });
    }
  };

  useEffect(() => {
    if (
      connectionStatus &&
      error?.message.includes("dynamically imported module")
    ) {
      resetErrorBoundary();
      return;
    }

    if (error) {
      logErrorBoundary(error);
    }
  }, [connectionStatus, error, resetErrorBoundary]);

  if (!connectionStatus) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center">
        <h4 className="text-base font-semibold text-brand-navy">
          Oops! No Internet Connection
        </h4>
        <p className="mt-2 text-sm text-gray-600">
          Please restart the application when the internet connection is
          restored.
        </p>
      </div>
    );
  }

  if (error && !error.message.includes("dynamically imported module")) {
    return (
      <>
        <button
          type="button"
          id="back-icon"
          className="mb-2 inline-flex min-h-touch min-w-touch items-center justify-center rounded-lg text-brand-navy hover:bg-gray-100"
          aria-label="Go back"
          onClick={() => navigate(-1)}
        >
          <span aria-hidden className="text-2xl leading-none">
            ←
          </span>
        </button>
        <div className="flex min-h-[40vh] flex-col items-center justify-center px-4 text-center">
          <h4 className="text-base font-semibold text-brand-navy">
            Something Went Wrong
          </h4>
        </div>
      </>
    );
  }

  return null;
};
